import React from "react";
import loadImage from "blueimp-load-image";
import IconStore from "./IconStore";
import "./index.css";
class AddServiceModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      content: "",
      tier1_title: "",
      tier2_title: "",
      tier1_img_src: require("../../../assets/media/picture.png"),
      tier2_img_src: require("../../../assets/media/picture.png"),
      tier1_img_url: "",
      tier2_img_url: "",
      onNext: false,
      src: "",
      store_visible: false
    };
  }
  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  selectedFile = e => {
    let _this = this;
    let id = e.target.id;
    let id_src = e.target.id + "_src";
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function(data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          function(canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            _this.setState({ [id]: img_src });
          },
          {
            canvas: true,
            orientation: orientation
          }
        );
      });
      this.setState({ [id_src]: URL.createObjectURL(e.target.files[0]) });
    }
  };
  complete = () => {
    const { addService } = this.props;
    const {
      tier1_img_url,
      tier1_title,
      tier2_img_url,
      tier2_title
    } = this.state;
    addService(tier1_img_url, tier2_img_url, tier1_title, tier2_title);
  };
  onSelectImage = url => {
    const { onNext } = this.state;
    console.log("onNext", onNext);
    if (!onNext) {
      console.log("tier1_img_url", url);
      this.setState({ tier1_img_url: url });
    } else {
      console.log("tier2_img_url", url);
      this.setState({ tier2_img_url: url });
    }
  };
  render() {
    const {
      tier1_img_url,
      tier2_img_url,
      tier1_img_src,
      tier2_img_src,
      tier1_title,
      tier2_title,
      onNext,
      store_visible,
      src
    } = this.state;
    return (
      <div
        className="modal fade"
        id="add_service"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add a new service branch</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {!onNext && (
              <div className="tier1_content">
                <label htmlFor="example-text-input">Tier1 Setting</label>
                <input
                  type="text"
                  name="tier1_title"
                  value={tier1_title}
                  className="form-control"
                  placeholder="Input tier1 title.."
                  onChange={this.onChange}
                />
                <button
                  className="service_button"
                  onClick={() => this.setState({ store_visible: true })}
                >
                  <img
                    src={tier1_img_url ? tier1_img_url : tier1_img_src}
                    alt="tier1_img"
                    width="70"
                  />
                  <p>{tier1_title}</p>
                </button>
              </div>
            )}
            {onNext && (
              <div className="tier2_content">
                <label htmlFor="example-text-input">Tier2 Setting</label>
                <input
                  type="text"
                  name="tier2_title"
                  value={tier2_title}
                  className="form-control"
                  placeholder="Input tier2 title.."
                  onChange={this.onChange}
                />
                <button
                  className="service_button"
                  onClick={() => this.setState({ store_visible: true })}
                >
                  <img
                    src={tier2_img_url ? tier2_img_url : tier2_img_src}
                    alt="tier2_img"
                    width="70"
                  />
                  <p>{tier2_title}</p>
                </button>
              </div>
            )}
            {store_visible && <IconStore onSelectImage={this.onSelectImage} />}
            {!onNext && (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={() => {
                    if (tier1_title && tier1_img_url)
                      this.setState({ onNext: true, store_visible: false });
                  }}
                >
                  Next
                </button>
              </div>
            )}
            {onNext && (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={() =>
                    this.setState({ onNext: false, store_visible: false })
                  }
                >
                  Back
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  data-dismiss="modal"
                  onClick={() => {
                    if (tier2_title && tier2_img_url) this.complete();
                  }}
                >
                  Done
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default AddServiceModal;



// WEBPACK FOOTER //
// ./src/screens/super_chatbots/components/AddServiceModal.js